import React, { useRef } from "react";
import { Modal, Col, Container, Row } from "react-bootstrap";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as yup from "yup";
import apiservice from "../../common/services/apiService";
import { showFormLoader, hideFormLoader } from "../../actions";
import { PHONE_REGEX } from "../../utils/common";
import ReCAPTCHA from "react-google-recaptcha";
import Image from "next/image";

const FreeConsultation = ({ show, hide }) => {
	const dispatch = useDispatch();
	const sitekey = process.env.NEXT_PUBLIC_RECAPTCHA_V3;
	const reCaptchaRef = useRef(null);

	const initialValues = {
		fullname: "",
		email: "",
		contact_number: "",
		project_summary: "",
	};

	const schema = yup.object({
		fullname: yup.string().required("Name is required."),
		email: yup.string().email("Invalid email.").required("Email is required."),
		contact_number: yup
			.string()
			// .required("Phone number is required")
			.min(9, "Invalid phone number")
			.max(13, "Invalid phone number")
			.matches(PHONE_REGEX, "Invalid phone number")
		// .required("Phone is required.")
		,
		project_summary: yup.string().required("Please tell us what you need."),
	});

	const validateCaptchaV3 = async () => {
		try {
			const token = await reCaptchaRef.current?.executeAsync();
			if (!token) {
				console.error("Captcha token is null");
				return null;
			}
			return token;
		} catch (error) {
			console.error("Captcha execution failed", error);
			return null;
		}
	};

	const onSubmit = async (values, { resetForm }) => {
		try {
			const isHuman = await validateCaptchaV3();
			if (!isHuman) {
				toast.error("ReCaptcha validation failed!");
				return;
			}

			console.log("Submitted Data:", isHuman);

			values["captcha_token_v3"] = isHuman;

			if (!!sessionStorage.getItem("hdd-referer")) {
				values["page_referer"] = sessionStorage.getItem("hdd-referer");
			}

			console.log("Submitted Data:", values);

			dispatch(showFormLoader());

			await apiservice.post("popup-rfp", values);
			toast.success("Form submitted successfully!");
			resetForm();
			hide();
			document.cookie = "popuprfp_submitted=true; max-age=2592000";
		} catch (error) {
			console.error("Form submission error:", error);
			toast.error("Something went wrong!");
		} finally {
			dispatch(hideFormLoader());
		}
	};

	return (
		<Modal show={show} onHide={hide} size="lg" centered className="modal-free-cunsultant">
			<Modal.Header closeButton className="border-0" />
			<Modal.Body>
				<Formik
					initialValues={initialValues}
					validationSchema={schema}
					onSubmit={onSubmit}
				>
					<Form>
						<Row>
							<Col md={6}>
								<div className="free-cunsultant text-light-black bg-two border-color border-one h-100">
									<div className="circle-container" />
									<div className="content-free">
										<div className="bg-white text-black border-color border-one boxone">
											<h3 className="h4">Hold On! Don’t Leave Without This...👋</h3>
										</div>
										<div className="bg-white text-black border-color border-one boxtwo">
											<p className="text-normal font-semibold">
												Your business deserves more than one-size-fits-all. Get a personalized roadmap—at no cost.
											</p>
											<ul>
												<li>A step-by-step strategy to bring your idea to life.</li>
												<li>Transparent cost estimates aligned with your goals.</li>
												<li>A timeline designed to ensure timely delivery.</li>
											</ul>
										</div>
										<div className="profile-image">
											{/* <img src="images/profile.png" alt="Profile" /> */}
											<Image
												src="/images/profile.png"
												alt="Profile"
												width={75}
												height={75}
											/>
										</div>
									</div>
								</div>
							</Col>

							<Col md={6}>
								<Row>
									<Col md={12}>
										<div className="form-group form-floating normal form-free-cunsult">
											<Field className="form-control" name="fullname" placeholder="Fullname*" id="fullname" />
											<label htmlFor="fullname" className="form-label">Full Name*</label>
											<ErrorMessage name="fullname" component="span" style={{ color: "red" }} />
										</div>
									</Col>

									<Col md={12}>
										<div className="form-group form-floating normal">
											<Field className="form-control" name="email" placeholder="Email*" id="email" />
											<label htmlFor="email" className="form-label">Email ID*</label>
											<ErrorMessage name="email" component="span" style={{ color: "red" }} />
										</div>
									</Col>

									<Col md={12}>
										<div className="form-group form-floating normal">
											<Field as="textarea" className="form-control" name="project_summary" id="project_summary" placeholder="Write project description" />
											<label htmlFor="project_summary" className="form-label">Tell Us What You Need</label>
											<ErrorMessage name="project_summary" component="span" style={{ color: "red" }} />
										</div>
									</Col>

									<Col md={12}>
										<div className="form-group form-floating normal">
											<Field className="form-control" name="contact_number" placeholder="Contact No" id="contact_number" />
											<label htmlFor="contact_number" className="form-label">Contact Number</label>
											<ErrorMessage name="contact_number" component="span" style={{ color: "red" }} />
										</div>

										<div className="sign-nda">
											<a href="#" className="text-ex-small font-regular text-light-black">
												<Image height={20} width={20} src="/images/home/tick-circle.svg" alt="" /> 100% confidential
											</a>
											<a href="#" className="text-ex-small font-regular text-light-black">
												<Image height={20} width={20} src="/images/home/tick-circle.svg" alt="" /> We sign NDA
											</a>
										</div>

										<div className="mt-4 d-flex justify-content-end">
											<button type="submit" className="btn btn-primary">
												Schedule free consultation
											</button>
										</div>

										<ReCAPTCHA
											style={{ display: "inline" }}
											theme="dark"
											size="invisible"
											ref={reCaptchaRef}
											sitekey={sitekey}
										/>
									</Col>
								</Row>
							</Col>
						</Row>
					</Form>
				</Formik>
			</Modal.Body>
		</Modal>
	);
};

export default FreeConsultation;
